import { render, staticRenderFns } from "./group-manage.vue?vue&type=template&id=8c139c2e&scoped=true"
import script from "./group-manage.vue?vue&type=script&lang=js"
export * from "./group-manage.vue?vue&type=script&lang=js"
import style0 from "./group-manage.vue?vue&type=style&index=0&id=8c139c2e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c139c2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c139c2e')) {
      api.createRecord('8c139c2e', component.options)
    } else {
      api.reload('8c139c2e', component.options)
    }
    module.hot.accept("./group-manage.vue?vue&type=template&id=8c139c2e&scoped=true", function () {
      api.rerender('8c139c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/components/group-manage.vue"
export default component.exports